
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { AlertSummaryComponent, NestedAlertSummaryComponent, DoubleNestedAlertSummaryComponent } from './alert-summary.component';



@NgModule({
  declarations: [
    AlertSummaryComponent,
    NestedAlertSummaryComponent,
    DoubleNestedAlertSummaryComponent,
  ],

  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
  ],

  exports: [
    AlertSummaryComponent,
    NestedAlertSummaryComponent,
    DoubleNestedAlertSummaryComponent,
  ],

  providers: [ ],

})

export class AlertSummaryModule { }
